<template>
  <div :class="['progress', hasTrackableContent && 'progress--light']">
    <span
      :class="[
        'progress__label',
        isPlaylistCompleted && 'progress__label--complete',
      ]"
    >
      {{ playlistStatusLabel }}
    </span>
    <span v-if="showProgress" class="progress__percentage">
      {{ progressLabel }}
    </span>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'PlaylistProgress',
  props: {
    userStatus: {
      type: Object,
      required: true,
    },
    userCompletion: {
      type: Object,
      required: true,
    },
    hasTrackableContent: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    ...mapGetters({
      isMarkAsCompletedEnabled: 'auth/isMarkAsCompletedEnabled',
    }),
    progress() {
      return this.userStatus.progress
    },
    percentage() {
      const value = this.progress * 100
      return Math.floor(value)
    },
    isPlaylistCompleted() {
      return this.progress === 1
    },
    playlistStatusLabel() {
      const { items_finished, items_started, items_total } = this.userCompletion
      if (this.isPlaylistCompleted || (!this.hasTrackableContent && items_started === items_total)) return 'Playlist complete!'
      return (!items_finished && !items_started) ? 'Not started' : 'In progress'
    },
    showProgress() {
      if (!this.isMarkAsCompletedEnabled) return true
      return this.hasTrackableContent
    },
    progressLabel() {
      return !this.isMarkAsCompletedEnabled
        ? this.percentageLabel
        : this.contentFinishedLabel
    },
    percentageLabel() {
      return this.percentage ? `${this.percentage}% complete` : ''
    },
    contentFinishedLabel() {
      const { items_finished, items_total } = this.userCompletion
      return `${items_finished}/${items_total} items finished`
    },
  },
}
</script>

<style lang="scss" scoped>
.progress {
  display: flex;
  flex-direction: column;
  justify-content: center;
  &__label {
    &--complete {
      color: var(--positive-light);
    }
  }
  &__percentage {
    color: var(--light-blue-gray);
  }
  &--light {
    span {
      color: var(--white);
    }
  }
}
</style>
